import React from 'react';
import OrderCard from './OrderCard';
import { parseOrderData } from '../Utils/orderParser';
import { getOrderStatus } from '../Utils/formatters';

const OrderList = ({
  orders,
  expandedKeys,
  processing,
  emailedKeys,
  printedKeys,
  showGunOrders,
  showPhotoOrders,
  onToggleExpand,
  onDelete,
  onEmail,
  onPrint,
  onCopyUrl,
  onUpdateEmail,
  onUpdateNotes,
  onShowQRCode,
  listView
}) => {
  // Sort orders by timestamp
  const sortedEntries = Object.entries(orders).sort(([ka, va], [kb, vb]) => {
    const a = parseOrderData(va);
    const b = parseOrderData(vb);
    if (a && b) return new Date(a.timestamp) - new Date(b.timestamp);
    if (a && !b) return -1;
    if (!a && b) return 1;
    return ka.localeCompare(kb);
  });

  // Filter orders based on type visibility
  const filteredEntries = sortedEntries.filter(([_, value]) => {
    const order = parseOrderData(value);
    if (!order) return true;
    if (order.type === "gun" && !showGunOrders) return false;
    if (order.type === "photo" && !showPhotoOrders) return false;
    return true;
  });

  const renderNonJsonKV = (key, value) => (
    <div key={key} className="kv-card">
      <div className="kv-header">
        <h3 className="kv-title">{key}</h3>
        <button
          className="btn btn-delete"
          onClick={() => onDelete(key)}
        >
          {processing[key]?.delete ? (
            <span className="spin">⟳</span>
          ) : (
            "Delete"
          )}
        </button>
      </div>
      <pre className="kv-value">
        {typeof value === "string" ? value : JSON.stringify(value, null, 2)}
      </pre>
    </div>
  );

  return (
    <div className="order-list">
      {filteredEntries.map(([key, value]) => {
        const order = parseOrderData(value);

        if (!order) {
          return renderNonJsonKV(key, value);
        }

        const isExpanded = expandedKeys.has(key);
        const status = getOrderStatus(key, order, emailedKeys, printedKeys);

        return (
          <OrderCard
            key={key}
            orderKey={key}
            order={order}
            isExpanded={isExpanded}
            processing={processing[key]}
            status={status}
            emailedKeys={emailedKeys}
            printedKeys={printedKeys}
            onToggleExpand={onToggleExpand}
            onDelete={onDelete}
            onEmail={onEmail}
            onPrint={onPrint}
            onCopyUrl={onCopyUrl}
            onUpdateEmail={onUpdateEmail}
            onUpdateNotes={onUpdateNotes}
            onShowQRCode={onShowQRCode}
          />
        );
      })}
    </div>
  );
};

export default OrderList;
